import { useEffect, useState } from 'react';
import { useContainer } from '../../useContainer';
import { OrganizationApi } from '../../../api';
import { BranchDto } from '../../../commonTypes/organization.types';

const useHttpGetBranchesFromOrganizationOMX = () => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const [data, setData] = useState<BranchDto[]>([]);
    const [isReady, setIsReady] = useState(false);

    const exec = () => {
        const { exec, abort } = organizationApi.getBranchesFromOrganization({
            onSuccess: res => {
                setData(res.body);
                setIsReady(true);
            },
            onError: error => {
                console.log(error);
                setIsReady(true);
            },
        });
        exec();
        return abort;
    };

    useEffect(() => {
        exec();
    }, []);

    return { isReady, data, exec };
};

export default useHttpGetBranchesFromOrganizationOMX;
